import { useAuthStore } from '@/auth/store/auth.store';
import { Navigate, Outlet } from 'react-router-dom';

export function PublicRoutes() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export function PrivateRoutes() {

  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
